// TODO: REFACTORING
import React, { useState } from 'react';
import LpForm from '../LpForm';
import Style from './style.module.css';
import './style.css';

const TripDetailNewPath = ({ title, description, form }) => {
  return (
    <section
      className={[Style.section, 'container', 'tripDetailNewPath'].join(' ')}
    >
      <span className={Style.anchor} id="new-path-anchor"></span>
      <h2 className={Style.title}>{title}</h2>
      <p className={Style.description}>{description}</p>
      <LpForm {...form} />
    </section>
  );
};

export default TripDetailNewPath;
